/**
 * useJumpToPage Hook
 *
 * 封装跳转逻辑：当 sessionId 尚未绑定完成（completeGetUnpl 为 false）时，
 * 展示全局 Loading，等待绑定完成后再执行跳转。
 * Loading 展示期间，任何组件的跳转都会被忽略（全局防重）。
 *
 * 使用场景：
 * 1. 搜索
 * 2. 团购商卡、外卖商卡
 * 3. 瓷片
 * 4. 红包去使用按钮
 */

import { useCallback } from 'react';
import { usePageState } from '@/context/PageStateContext';
import { jumpToPage as _jumpToPage, JumpConfig } from '@/lib/jumpPage';

export function useJumpToPage() {
  const { completeGetUnpl, waitForUnpl, jumpLoading, setJumpLoading } = usePageState();

  const jumpToPage = useCallback(
    async (config: JumpConfig) => {
      // jumpLoading 为 true 说明已有跳转在等待中，全局防重
      if (jumpLoading) return;

      if (!completeGetUnpl) {
        setJumpLoading(true);
        await waitForUnpl();
        setJumpLoading(false);
      }

      _jumpToPage(config);
    },
    [completeGetUnpl, waitForUnpl, jumpLoading, setJumpLoading],
  );

  return jumpToPage;
}
